import styled from "styled-components";

export const LeadViewContainer = styled.section`
  display: flex;
  flex-direction: column;
  width: ${(props) => props.maineWidth ?? "100%"};
  margin-top: 10px;
  background-color: white;
  padding-bottom: 30px;
  border-radius: 4px;
  margin-left: ${(props) => props.marginLeft ?? "0px"};
  margin-right: auto;
  padding: 1.375rem;
  padding-right: 2rem;
  background: linear-gradient(
    180deg,
    rgba(255, 255, 255, 0) 0%,
    rgba(255, 255, 255, 0.5) 14.95%,
    rgba(0, 76, 127, 0.1) 100%
  );
`;
export const ParentDetail = styled.h2`
  color: #004c7f;
  font-size: 13px;
  font-family: lato;
  font-style: italic;
  text-transform: initial;
  margin-bottom: 10px;
  line-height: 1;
  margin-top: 3px;
  font-weight: bold !important;
  display: inline-flex;
`;

export const GridRow = styled.div`
  display: grid;
  grid-template-columns: ${(props) => props.column ?? "1fr"};
  gap: ${(props) => props.gap ?? "1.25rem"};
  margin-bottom: ${(props) => props.marginBottom ?? "10px"};
  font-weight: normal;
  margin-top: ${(props) => props.marginTop ?? "10px"};
`;

export const MapContainer = styled.div`
  border-radius: 4px;
  position: relative;
  height: ${(props) => props.height ?? "160px;"};
  overflow: hidden;
  outline: none;
  box-shadow: 0px 4px 4px rgba(63, 56, 56, 0.25);
  margin: 0 1.375rem;
  width: auto;
  border: solid 1px #00aeea;
  margin-bottom: 10px;
  margin-top: ${(props) => props.marginTop ?? "0px;"};
`;

export const GridSubItem = styled.div`
  color: ${(props) => props.color ?? "#0a4986"};
  font-style: ${(props) => props.fontStyle ?? "italic"};
  font-weight: ${(props) => props.fontWeight ?? "400"};
  font-size: ${(props) => props.fontSize ?? "14px"};
  text-align: ${(props) => props.textAlign ?? "left"};
`;

export const DocumentName = styled.a`
  position: relative;
  font-size: 14px;
  line-height: 16px;
  color: #1bace4 !important;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  text-decoration: none !important;
  cursor: pointer;
  text-transform: initial;
  margin: 0;
`;
